// @ts-ignore
import { version, build } from '../../../../app/web/version';

export default class PrintVersion {

    public contentNodeId        : string = 'idPrintContainer'
    public pageTitle            : string = 'Print version';
    public cssFileName          : string = '';
    public autoPrintDelay       : number = 1500;

    constructor() {
        // this.contentNodeId = 'idPrintContainer';
        // this.pageTitle = 'Print version';
        // this.cssFileName = '';
        // this.autoPrintDelay = 1500;
    }

    // usually ovveridden
    getPageContent() {
        const printContainer = document!.getElementById('idPrintContainer')!.cloneNode(true);

        // pastdue, priorities: users
        // @ts-ignore
        printContainer.querySelectorAll('.user').forEach(node => {

            const userId = /*node.dataset ? node.dataset.userId :*/ node.getAttribute('data-user-id');
            if (userId) {
                const user = gd.session.users.get(userId);
                if (user) {
                    node.innerHTML = user.name;
                }
            }
        });

        return printContainer
    }

    get cssFilePath() {
        return '/app/web/skin/print/' + this.cssFileName + '?' + build;
    }

    get htmlContent() {
        return document!.getElementById(this.contentNodeId)!.cloneNode(true);
    }

    async print() {

        const randStr = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
        const wnd : any = window.open('about:blank', 'PrintVersion-' + randStr);

        wnd.document.write('<!DOCTYPE html><html class="print-version">');
        wnd.document.writeln('<head>');
        wnd.document.writeln('<title>' + this.pageTitle +  '</title>');
        wnd.document.writeln('<link rel="stylesheet" type="text/css" href="'+this.cssFilePath+'">');
        wnd.document.writeln('</head>');
        // it's in separate funtion to be able to ovveride i.e. in Note View
        await this._insertContentIntoBody(wnd)
        wnd.document.writeln('</html>');
        wnd.document.close();

        setTimeout(() => {
            wnd.focus();
            wnd.print();
        }, this.autoPrintDelay);

    }

    _insertContentIntoBody(wnd:any) {
        // @ts-ignore
        wnd.document.writeln('<body>' + this.getPageContent().outerHTML  +  '</body>');
    }



}